/**
 * ArrowRight — a thin, round-capped rightwards arrow. Replaces the heavy
 * U+2192 glyph that rendered blocky in the mono font. Inherits colour via
 * currentColor and sits on the text baseline, so it drops into a link label
 * or a date range without extra styling.
 */
interface ArrowRightProps {
  /** Glyph box size in px. Default 14 suits body/mono text. */
  size?: number;
}

export function ArrowRight({ size = 14 }: ArrowRightProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden
      focusable="false"
      style={{ display: 'inline-block', verticalAlign: '-0.12em', flex: 'none' }}
    >
      <path
        d="M3 8h9M8.5 4.5 12 8l-3.5 3.5"
        stroke="currentColor"
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
